(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moha-skin-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moha-skin-quiz')) {
    const RULES = { minScore: 6, minLead: 2, minClear: 4 };
    const SCORE_KEYS = { a: 'dry', b: 'combination', c: 'oily' };

    const evaluateSkinQuiz = (answers, questions, rules) => {
      const scores = { dry: 0, combination: 0, oily: 0 };
      let clearAnswers = 0;

      for (let i = 0; i < questions.length; i++) {
        const answer = answers[i];
        if (!answer) return null;
        if (answer === 'd') {
          if (questions[i].decisive) return 'unclear';
          continue;
        }
        clearAnswers++;
        scores[SCORE_KEYS[answer]] += questions[i].weight;
      }

      if (clearAnswers < rules.minClear) return 'unclear';

      const ranked = Object.entries(scores).sort((x, y) => y[1] - x[1]);
      const [top, second] = ranked;
      if (top[1] >= rules.minScore && top[1] - second[1] >= rules.minLead) return top[0];
      return 'unclear';
    };

    class MohaSkinQuiz extends HTMLElement {
      connectedCallback() {
        this.intro = this.querySelector('[data-step="intro"]');
        this.form = this.querySelector('[data-step="questions"]');
        this.details = this.querySelector('[data-step="details"]');
        this.questions = [...this.querySelectorAll('[data-question]')];
        this.detailFields = [...this.details.querySelectorAll('input, select')];
        this.results = [...this.querySelectorAll('[data-step="result"]')];
        this.countryCode = this.querySelector('[data-country-code]');
        this.mobile = this.querySelector('[data-mobile]');
        this.counter = this.querySelector('[data-counter]');
        this.progressBar = this.querySelector('[data-progress-bar]');
        this.nav = this.querySelector('[data-nav]');
        this.nextBtn = this.querySelector('[data-action="next"]');
        this.index = 0;

        this.querySelector('[data-action="start"]').addEventListener('click', () => this.start());
        this.querySelector('[data-action="back"]').addEventListener('click', () => this.go(this.index - 1));
        this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
        this.form.addEventListener('change', () => this.updateNav());
        this.countryCode.addEventListener('change', () => this.updateMobilePattern());
        // The details fields and "See my results" button submit this form via their form attribute.
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.finish();
        });
        this.querySelector('[data-action="retake"]').addEventListener('click', () => this.retake());
      }

      answerAt(i) {
        const checked = this.questions[i].querySelector('input:checked');
        return checked ? checked.value : null;
      }

      // Indian numbers are exactly 10 digits; other countries vary.
      updateMobilePattern() {
        const india = this.countryCode.value === '+91';
        this.mobile.pattern = india ? '[0-9]{10}' : '[0-9]{6,14}';
        this.mobile.placeholder = india ? '10-digit mobile' : 'Mobile number';
      }

      // Sends one row to the Google Sheet set in the section settings.
      submitLead(lead) {
        const sheetUrl = this.dataset.sheetUrl;
        if (!sheetUrl) return;

        const row = new URLSearchParams({ timestamp: new Date().toISOString(), ...lead, page: location.href });
        // Apps Script web apps don't send CORS headers, so the response can't be read; no-cors still delivers the row.
        fetch(sheetUrl, { method: 'POST', mode: 'no-cors', body: row, keepalive: true }).catch(() => {});
      }

      transition(update) {
        if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          document.startViewTransition(update);
        } else {
          update();
        }
      }

      showOnly(panel) {
        [this.intro, this.form, this.details, ...this.results].forEach((el) => (el.hidden = el !== panel));
        const inQuiz = panel === this.form;
        this.nav.hidden = !inQuiz;
        this.counter.hidden = !inQuiz;
      }

      start() {
        this.transition(() => {
          this.showOnly(this.form);
          this.go(0);
        });
      }

      go(i) {
        if (i < 0) {
          this.transition(() => {
            this.showOnly(this.intro);
            this.progressBar.style.width = '0%';
            this.intro.querySelector('.msq__intro-title').focus();
          });
          return;
        }
        if (i >= this.questions.length) {
          this.showDetails();
          return;
        }
        this.index = i;
        this.questions.forEach((q, n) => (q.hidden = n !== i));
        this.updateNav();
        this.questions[i].querySelector('legend').focus();
      }

      showDetails() {
        this.transition(() => {
          this.showOnly(this.details);
          this.progressBar.style.width = '100%';
          this.details.querySelector('.msq__title').focus();
        });
      }

      updateNav() {
        const total = this.questions.length;
        const isLast = this.index === total - 1;

        this.counter.textContent = `Step ${this.index + 1}/${total}`;
        this.progressBar.style.width = `${((this.index + 1) / total) * 100}%`;
        this.nextBtn.textContent = isLast ? 'Continue' : 'Next';
        this.nextBtn.disabled = !this.answerAt(this.index);
      }

      finish() {
        const answers = this.questions.map((_, i) => this.answerAt(i));
        const firstMissing = answers.findIndex((a) => !a);
        if (firstMissing !== -1) {
          this.showOnly(this.form);
          this.go(firstMissing);
          return;
        }
        const invalid = this.detailFields.find((field) => !field.checkValidity());
        if (invalid) {
          invalid.reportValidity();
          return;
        }

        const questions = this.questions.map((q) => ({
          weight: Number(q.dataset.weight),
          decisive: q.dataset.decisive === 'true',
        }));
        const outcome = evaluateSkinQuiz(answers, questions, RULES);
        const panel = this.results.find((r) => r.dataset.outcome === outcome);

        this.transition(() => {
          this.showOnly(panel);
          panel.querySelector('.msq__skin-type').focus();
        });

        const data = new FormData(this.form);
        const value = (name) => (data.get(name) || '').trim();
        const lead = {
          name: value('name'),
          age: value('age'),
          phone: `${value('country_code')} ${value('mobile')}`,
          email: value('email'),
          skin_type: outcome,
          sample: value('sample'),
        };
        // q1, q2, … hold the answer text exactly as the customer saw it.
        this.questions.forEach((q, i) => {
          lead[`q${i + 1}`] = q.querySelector('input:checked + span').textContent.trim();
        });
        this.submitLead(lead);

        this.dispatchEvent(
          new CustomEvent('moha:skin-quiz:result', { bubbles: true, detail: { outcome, answers, lead } })
        );
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: 'skin_quiz_result', skin_type: outcome, sample_optin: lead.sample });
        }
      }

      retake() {
        this.form.reset();
        this.updateMobilePattern();
        this.start();
      }
    }

    customElements.define('moha-skin-quiz', MohaSkinQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
